import React, { Component } from 'react';
import { store } from '../redux/store';
import { initialPagePath } from '../redux/reducers/PageReducer';
import ComponentName from '../constant/ComponentName';
import FolderService from '../service/FolderService';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import Breadcrumb from '../components/Breadcrumb';
import Icon from '../icons/Icon';
import CustomTabv2 from '../components/custom/CustomTabv2';
import WatchlistAlertListComponent from '../components/kyc/alert/WatchlistAlertListComponent';
import { WatchlistType } from '../constant/Constants';
import WatchlistService from '../service/WatchlistService';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import ValueUtil from '../util/ValueUtil';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../util/LanguageUtil';

class WatchlistAlertContainer extends Component<Props, State> {
  public state: State = new State();

  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private alertCountIntervalId: any = null;

  render() {
    const { type } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-y-hidden'>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'flex justify-between p-5'}>
          <div className={'flex'}>
            <span
              key={'icon'}
              className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
            >
              <Icon icon={'watchlist-alert'} className={'hidden w-[24px] h-[24px] 2xl:w-[34px] 2xl:h-[34px]'} color={'#728EFF'} />
            </span>
            <div className={'flex flex-col justify-center pl-3'}>
              <span className={'text-[24px] 2xl:text-4xl font-normal'}>{LanguageUtil.get({ id: 'pages.watchlist.alertPage' })}</span>
              <span className={'text-md font-normal !text-f-black-3'}>
                {LanguageUtil.get({ id: 'pages.watchlist.sanctionsAlert', defaultMessage: `${type} sanctions watchlist alerts` }, { 0: `${type}` })}
              </span>
            </div>
          </div>
        </div>
        <div className={'flex flex-col overflow-y-scroll h-full w-full'}>
          <CustomTabv2 tab={this.getTabs()} onClick={(e, tab: any) => this.setState({ type: tab })} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const {
      router: { location },
    } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST_ALERT];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST_ALERT, location.pathname, store.getState().page);
    }
    this.handleAlertCounts();
  }

  public componentWillUnmount = async () => {
    clearInterval(this.alertCountIntervalId);
  };

  private handleAlertCounts = () => {
    this.onHandleAlertCounts();
    this.alertCountIntervalId = setInterval(async () => {
      await this.onHandleAlertCounts();
    }, 10_000);
  };

  private onHandleAlertCounts = async () => {
    try {
      const alertCounts: Record<string, number> = await this.watchlistService.getAlertCounts();
      this.setState({ alertCounts });
    } catch (e) {
      console.error(e);
    }
  };

  protected getTabs = () => {
    const { type, alertCounts } = this.state;

    return [
      {
        key: 'General',
        label: LanguageUtil.get({ id: 'common.tabs.all', defaultMessage: 'All' }),
        content: <WatchlistAlertListComponent type={type} key={type} openInNewPage />,
        badgeValue: ValueUtil.numberShorten((alertCounts['individual'] || 0) + (alertCounts['entity'] || 0)),
      },
      {
        key: 'Individual',
        label: LanguageUtil.get({ id: 'common.tabs.individual', defaultMessage: 'Individual' }),
        content: <WatchlistAlertListComponent type={type} key={type} openInNewPage />,
        badgeValue: ValueUtil.numberShorten(alertCounts['individual'] || 0),
      },
      {
        key: 'Entity',
        label: LanguageUtil.get({ id: 'common.tabs.entity', defaultMessage: 'Entity' }),
        content: <WatchlistAlertListComponent type={type} key={type} openInNewPage />,
        badgeValue: ValueUtil.numberShorten(alertCounts['entity'] || 0),
      },
    ];
  };
}

class State {
  type: WatchlistType = 'General';
  alertCounts: Record<string, number> = {};
}

interface Props extends FormicaProps {}

export default withFormica(WatchlistAlertContainer);
